const headRowsTypeService = {
  actions:'Action',
  name: 'Service Types'
};

export default headRowsTypeService;
